
export const Heading = ({ children }) => {
  return <h1 className="stepper-form-heading">{children}</h1>;
};
